import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";

export const addToCombinedCateringCart = async (payload) => {
  try {
    const response = await apiClient.post(API_ENDPOINTS.ADD_TO_COMBINED_CATERING_CART, payload);
    return response.data;
  } catch (error) {
    console.error("Error adding to combined catering cart:", error);
    throw error;
  }
};

